/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchFreelancerAccountRequest
 */
export interface SearchFreelancerAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchFreelancerAccountRequest
     */
    query: string;
}

/**
 * Check if a given object implements the SearchFreelancerAccountRequest interface.
 */
export function instanceOfSearchFreelancerAccountRequest(value: object): value is SearchFreelancerAccountRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function SearchFreelancerAccountRequestFromJSON(json: any): SearchFreelancerAccountRequest {
    return SearchFreelancerAccountRequestFromJSONTyped(json, false);
}

export function SearchFreelancerAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFreelancerAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
    };
}

export function SearchFreelancerAccountRequestToJSON(value?: SearchFreelancerAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
    };
}

